import { createContext, useContext, useState } from "react";

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [loaderDone, setLoaderDone] = useState(false);
  const [enquiry, setEnquiry] = useState({ open: false, service: "Concierge" });

  const openEnquiry = (service = "Concierge") => setEnquiry({ open: true, service });
  const closeEnquiry = () => setEnquiry((e) => ({ ...e, open: false }));

  return (
    <UIContext.Provider
      value={{ loaderDone, setLoaderDone, enquiry, openEnquiry, closeEnquiry }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => useContext(UIContext);
